export default __webpack_public_path__ + "static/media/Poderes of Illuminant Conviction.f12f42d6.jpg";